export const ELEMENTS_CHANNEL = 'fabric-elements';
export const UNKNOWN_USER_ID = '_|unknown|_';
